<template>
  <div style="background-color: #f5f5f5;">
    <headers></headers>
    <!--<carousel></carousel>-->
    <p class="banner padding88"><img :src="sliderImg" alt="" height="200px" width="100%"></p>
    <div class="divider ">
      <div class="auto">
        <router-link to="/">首页</router-link><span>></span>学分转换
      </div>
    </div>
    <div class="auto padding250">
      <div class="top">
        <div class="left">
          <p class="label">学分银行</p>
          <p class="text">以学分银行为基础，构建“衔接沟通各级各类教育，认可多种学习成果的终身学习立交桥”建立学历和非学历融通、线上线下教学相结合的新型行业学习生态圈。</p>
          <router-link to="/kaoshiAccount"><img src="../../assets/my.png" alt=""> 我的账号</router-link>
          <router-link to="/xuefentransform"><img src="../../assets/transform.png" alt="" class="transform"> 学分转换</router-link>
        </div>
        <img src="../../assets/huanzheng.png" alt="" class="bg">
      </div>
      <div class="auto">
        <div class="container clearfix font14" v-html=html style="text-align: left;">
        </div>
      </div>
    </div>
    <Spin fix v-show="isSpinShow" >
      <div class="loader">
        <Icon type="ios-loading" size=26 class="demo-spin-icon-load"></Icon>
        <div class="font14">加载中...</div>
      </div>
    </Spin>
    <footers></footers>
  </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">
  /* 旋转效果 */
  .demo-spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
  }
  @keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50% { transform: rotate(180deg);}
    to { transform: rotate(360deg);}
  }
  /* 假如内容过长，一屏放不下，滚动条下拉覆盖不全 */
  .ivu-spin-fix {
    position: fixed;
  }

  .banner{
    height: 260px;
  }
  .divider{
    height: 53px;
    background-color: #fff;
    font-size: 14px;
    color: #957960;
    line-height: 53px;
    text-align: left;
    margin-bottom: 30px;
    box-shadow: 5px 1px 10px #ccc;
    a{
      color: #957960;
      &:hover{
        color: #9C7649;
        font-weight: 700;
      }
    }
    span{
      margin: 0 10px;
    }
  }


  form{
    width: 360px;
    margin:50px  0 0 50px ;
  }
  .title{
    font-size: 20px;
    color: #000;
    margin: 20px 0 25px 0;
    text-align: left;
    padding: 15px 20px ;
    background-color: #fff;
  }
  .sex .ivu-form-item-content{
    text-align: left;
  }
  .ceping_form .ivu-date-picker{
    width: 250px;
  }
  /*.container{
    background-color: #fff;
    padding: 50px 0;
    .sex{
      text-align: left;
      div{
        display: inline-block;
        margin-right: 30px;
        font-size: 14px;

        img{
          vertical-align: middle;
          margin-right: 10px;
        }
      }
    }
    .upload{
      width: 715px;
      >div{
        display: inline-block;
        font-size: 12px;
        margin:0 35px 5px 0;
        text-align: center;
        cursor: pointer;
        p{
          width: 209px;
          height: 118px;
          border:1px solid #e1e1e1;
          padding: 10px 5px;
          img{
            object-fit: contain;
          }
        }
      }
    }
    .upload_tip{
      margin-bottom: 20px;
      color: #FF0000;
      padding-left: 20px;

    }
    .nextbtn{
      background-color: #957960;
      height: 55px;
      width: 221px;
      font-size: 18px;
      color: #fff;
      margin-left:-30px;
    }
  }*/
  .top{
    background-color: #fff;
    padding: 30px;
    margin:30px 0;
    text-align: left;
    position: relative;
    .bg{
      position: absolute;
      bottom: 0;
      right: 0px;
    }
    .left{
      width: 590px;
      img{
        vertical-align: text-top;
      }
      .transform{
        margin-top: 2px;
      }
    }
    .label{
      font-size: 22px;
      color: #000;
      font-weight: 700;
    }
    .text,.text1{
      font-size: 14px;
      color: #999;
      line-height: 25px;
      margin: 20px 0;
    }
    .text1{
      color: #666;
    }
    a{
      background-color: #B2936B;
      color: #fff;
      display: inline-block;
      width: 150px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      border-radius: 5px;
      font-size: 18px;
      margin-right: 30px;
    }
  }
  .container {
    background-color: #fff;
    padding: 41px 41px;
    line-height: 30px;
  }
</style>
<script type="text/ecmascript-6">
  import headers from '../template/header'
  import footers from '../template/footer'
  import carousel from '../template/carousel'
  import {getStore} from "../../storage";
  import {getHtmlWeb,sliderPC} from '../../http'
  export default {
        name: '',
        props: {},
        data() {
            return {
              html:'',
              sliderImg:'',
              isSpinShow:false,
            };
        },
        methods: {
          getZhuanhuan() {
            if (this.isSpinShow === false) {
              this.isSpinShow = true;
              //获取封面图
              sliderPC({sliderType:'5'}).then(res =>{
                this.sliderImg = res.data.slider.sliderImg;
              }).catch()
              //获取页面
              getHtmlWeb({type: 'creditBank'}).then(res => {
                this.isSpinShow = false;
                this.html = res.data.html.htmlContent;
              }).catch()
            }
          }
        },
        created() {
          this.getZhuanhuan()
        },
      components: {
        headers,
        footers,
        carousel
      }
    }
</script>



// WEBPACK FOOTER //
// src/components/other/zhuanhuan.vue